import { ControlsToggleExtraContent, LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

export const component: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 2,
        rows: 2,
        colSpan: {
          "0:0": 2,
        },
        rowsSize: [2, 1],
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/03/principle/low-sound-barrier-image.svg`,
                  },
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    formatter: "html",
                    scrollbars: false,
                    data:
                      "<b>Description</b></br></br>There is a low sound barrier between the loudspeaker and the listener of 2 m height. Only one diffracted sound ray can reach the listener propagating above the top of the barrier (in blue), and there is no direct sound (dotted red line). The sound examples are quieter due to the barrier effect, and the high frequencies are more attenuated than the low frequencies, changing the timbre of the sounds.",
                  },
                },
                styles: {
                  alignItems: "flex-start",
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/03/principle/low-sound-barrier-chart.svg`,
                  },
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export const extraContent: ControlsToggleExtraContent = [
  {
    type: "audioButton",
    options: {
      theme: "primary",
      url: `${config.ASSETS_URL}/05/03/principle/low-sound-barrier-voice.wav`,
      text: "Voice",
      icon: "cil-volume",
      shape: "round",
    },
  },
  {
    type: "audioButton",
    options: {
      theme: "primary",
      url: `${config.ASSETS_URL}/05/03/principle/low-sound-barrier-drums.wav`,
      text: "Drums",
      icon: "cil-volume",
      shape: "round",
    },
  },
];
